// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blogs-screen--layout {\n  padding: 30px 120px; }\n  @media screen and (max-width: 960px) {\n    .blogs-screen--layout {\n      padding: 20px; } }\n", ""]);
// Exports
module.exports = exports;
